<template>
    <div class="record-report-container">
        <div class="t-top-bar">
            <div class="report-op">
                <div>
                  <el-input placeholder="员工编号、员工姓名" v-model="keyword" class="search-input"></el-input>
                  <el-cascader class="search-input" clearable v-model="searchDepart" placeholder="所属班组" :options="treeData"
                               :props="{ expandTrigger: 'hover', label: 'name',value:'departmentId' }"></el-cascader>
                  <el-select class="search-input200" clearable v-model="subEquipmentId" placeholder="终端编号">
                      <el-option v-for="(val,key) in subEquipments" :key="key" :label="val.equipmentId"
                                 :value="val.equipmentId"></el-option>
                  </el-select>
                  <el-select  class="search-input200" clearable v-model="priceType" placeholder="计价类型">
                      <el-option v-for="(val,key) in selectDic('PRICE_TYPE')" :key="key" :label="val.name" :value="val.code"></el-option>
                  </el-select>
                  <el-date-picker style="margin-top: 10px"  v-model="selectTime" type="datetimerange" :picker-options="pickerOptions"
                          range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"
                          align="right"></el-date-picker>
                </div>
              <div style="margin-top:10px">
                <el-select class="search-input200" clearable v-model="selectedpst.productionId" placeholder="产品" @change="productionChange">
                  <el-option v-for="(val,key) in productfilter" :key="key" :label="val.name"
                             :value="key"></el-option>
                </el-select>
                <el-select class="search-input200" clearable v-model="selectedpst.specId" placeholder="规格">
                  <el-option v-for="(val,key) in specfilter" :key="key" :label="val"
                             :value="key"></el-option>
                </el-select>
                <el-select class="search-input200" clearable v-model="selectedpst.tecId" placeholder="工艺">
                  <el-option v-for="(val,key) in tecfilter" :key="key" :label="val"
                             :value="key"></el-option>
                </el-select>
              </div>
            </div>
            <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
<!--            <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>-->
            <div class="report-op"><el-button style="margin: 0" type="primary"  @click="edit">修改</el-button></div>
            <div class="report-op">
              <el-upload  title="导入记录"
                         class="upload-demo" :data="uploadParam"
                         :action="uploadUrl" :show-file-list="false"
                         :multiple="false" :on-success="uploadHandler" :on-progress="uploadProgressHandler">
                <el-button type="primary">导入</el-button>
              </el-upload>
            </div>
          <div class="report-op"><el-button style="margin: 0" type="primary"  @click="exportExcel">导出</el-button></div>
          <div class="report-op" style="width:85px"><a title="导入模板下载" href="/recordimport.xlsx" download="记录导入模板">导入模板</a></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%"  height="620" v-loading="listLoading"
                  @selection-change="selectionChange" >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100"></el-table-column>
          <el-table-column prop="staff_no" label="工号" width="100"></el-table-column>
          <el-table-column prop="staff_name" label="员工名称" width="100"></el-table-column>
          <el-table-column prop="production_name" label="产品名称" width="180"></el-table-column>
          <el-table-column prop="spec_name" label="规格名称" width="100"></el-table-column>
          <el-table-column prop="technology_name" label="工艺名称" width="150"></el-table-column>
          <el-table-column prop="calc_kg" label="计价量" width="120"></el-table-column>
          <el-table-column prop="dispatch_kg" label="发料量" width="90"></el-table-column>
          <el-table-column prop="delivery_kg" label="交料量" width="90"></el-table-column>
          <el-table-column prop="staff_type" label="员工类型" width="100">
            <template slot-scope="scope">
              {{scope.row.staff_type | dicFilter('STAFF_TYPE')}}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价(元)" width="100"></el-table-column>
          <el-table-column prop="total_price" label="总价(元)" width="100"></el-table-column>
          <el-table-column prop="record_time" label="记录时间" width="180">
            <template slot-scope="scope">
              {{scope.row.record_time | formateTime()}}
            </template>
          </el-table-column>
          <el-table-column prop="report_time" label="上传时间" width="180">
            <template slot-scope="scope">
              {{scope.row.report_time | formateTime()}}
            </template>
          </el-table-column>
            <el-table-column prop="dispatch_sub_id" label="发料终端" width="110px"></el-table-column>
            <el-table-column prop="delivery_sub_id" label="交料终端" width="110px"></el-table-column>

            <el-table-column prop="department_name" label="组别" width="180px"></el-table-column>
            <el-table-column prop="batch_name" label="批次"></el-table-column>

            <el-table-column prop="shift_name" label="班次">
                <template slot-scope="scope">
                    {{scope.row.shift_name || '--'}}
                </template>
            </el-table-column>
            <el-table-column prop="price_type" label="计价类型" width="100">
                <template slot-scope="scope">
                    {{scope.row.price_type | dicFilter('PRICE_TYPE')}}
                </template>
            </el-table-column>

            <el-table-column prop="yield" label="出成率(%)" width="90"></el-table-column>

        </el-table>

      <el-dialog title="记录修改" @close="editCloseHandler" :visible.sync="editDialogVisiable" width="650px">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="重量(kg)" prop="weight" :label-width="formLabelWidth">
            <el-input v-model="editForm.weight" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="价格(元)" prop="price" :label-width="formLabelWidth">
            <el-input v-model="editForm.price" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisiable = false">取 消</el-button>
          <el-button type="primary" @click="editConfirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
    import { getRecordList } from '../../api/record'
    import {dataprint, tableDataToExcel} from '../../util/util'
    import { getEquipmentListAll } from '../../api/equipment'
    import { getDepartmentList } from '../../api/department'
    import localCache from "../../util/localCache";
    import {editRecord} from "@/api/recordEdit";
    export default {
        name: "recordReport",
        data(){
          let reg = /^\d{0,5}\.?\d{0,2}$/
          let checkPrice = (rule, value, callback) => {
            if(value === ''){
              callback();
            }
            if (!reg.test(''+value)) {
              callback(new Error('请输入合法数值'));
            } else {
              if (value < 0 || value > 99999) {
                callback(new Error('数值范围0-99999'));
              } else {
                callback();
              }
            }
          }
            return {
                listLoading: false,
                tableData: [],
                cacheData: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                selectTime: '',
                keyword: '',
                exportColumn: {
                    'staff_no':'员工编号',
                    'staff_name':'员工名称',
                    'production_name':'产品名称',
                    'technology_name':'工艺名称',
                    'spec_name':'规格名称',
                    'batch_name':'批次名称',
                    'calc_kg':'计价重量(kg)',
                    'dispatch_kg':'发料(kg)',
                    'delivery_kg':'交料(kg)',
                    'price':'单价(元)',
                    'total_price':'总价(元)',
                    'record_time':'记录时间',
                    'record_id':'记录编号',
                    'customer_id':'客户编号',
                    'equipment_id':'设备编号',
                    'dispatch_sub_id':'发料终端',
                    'delivery_sub_id':'交料终端',
                    'dispatch_card_no':'发料卡号',
                    'delivery_card_no':'交料卡号',
                    'price_type':'计价类型',
                    'delivery_count':'交料(数量)',
                    'yield':'出成率(%)',
                    'price_id':'计价规则编号',
                    'staff_type':'员工类型',
                    'department_id':'组编号',
                    'department_name':'组名称',
                    'production_id':'产品编号',
                    'spec_id':'规格编号',
                    'technology_id':'工艺编号',
                    'shift_id':'班次编号',
                    'shift_name':'班次',
                    'delay_time':'班次延时',
                    'batch_id':'批次编号',
                    'report_time':'上报时间',
                    'calc_time':'计算时间',
                    'year':'年',
                    'month':'月',
                    'day':'日',
                    'append':'备注',
                },
                subEquipments: [],
                subEquipmentId:'',
                searchDepart:'',
                treeData: [],
                priceType:'',
                productfilter: {},
              specfilter: {},
              tecfilter: {},
              selectedpst:{
                productionId: '',
                specId: '',
                tecId: ''
              },
              oldselectedpst:{
                productionId: '',
                specId: '',
                tecId: ''
              },
              selectOrderId: [],
              orderIdArr: [],
              selectRows: [],
              formLabelWidth: '80px',
              editDialogVisiable: false,
              editForm:{
                weight: '',
                price: ''
              },
              rules:{
                weight: [
                  { validator: checkPrice, trigger: 'blur' }
                ],
                price: [
                  { validator: checkPrice, trigger: 'blur' }
                ]
              },
              uploadLoading: '',
              uploadUrl: process.env.VUE_APP_BASE_API+'/fileupload',
              uploadParam:{
                type: 6,
              }
            }
        },
      watch:{
        selectedpst:{//深度监听，可监听到对象、数组的变化
          handler(val, oldVal){
            console.log(val.productionId, oldVal.productionId);
            let productionId = val.productionId, specId = val.specId, tecId = val.tecId
            if(productionId != this.oldselectedpst.productionId){
              this.selectedpst = {
                productionId: productionId,
                specId: '',
                tecId: ''
              }
              this.oldselectedpst={
                productionId: productionId,
                specId: '',
                tecId: ''
              }
              return
            }
            this.oldselectedpst = {
              productionId: productionId,
              specId: specId,
              tecId: tecId
            }
            if(!productionId && !specId && !tecId){
              this.tableData = this.cacheData.slice(0)
              return
            }
            let arr = this.cacheData.filter((t)=>{
              let p = true
              if(productionId){
                p = t.production_id == productionId
              }
              let s = true
              if(specId){
                s = t.spec_id == specId
              }
              let te = true
              if(tecId){
                te = t.technology_id == tecId
              }
              return p && s && te
            })
            this.tableData = arr.slice(0)
          },
          deep:true //true 深度监听
        }
      },
        mounted(){
            let now = new Date()
            let start = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0)
            this.selectTime = [start,now]
            this.getRecordList_()
            this.getEquipmentListAll_()
            this.getTree()
                this.uploadParam.customerId = localCache.getCurrentCustomerId()
          this.uploadParam.token = localCache.getToken()
        },
        methods: {
          uploadHandler(res, file, fileList){
            if (res.errorcode !== 0) {
              this.$message.error(res.message)
            } else {
              this.$message.success('导入成功')
              this.getRecordList_()
            }
            this.uploadLoading.close()
          },
          uploadProgressHandler(event, file, fileList){
            this.uploadLoading = this.$loading({
              lock: true,
              text: '导入中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          },
          selectionChange(val){
            this.selectRows = val
          },
          editConfirm(){
            this.$refs['editForm'].validate((valid) => {
              if (!valid) {
                return
              }
              let param = Object.assign({}, this.editForm)
              param.customerId = localCache.getCurrentCustomerId()
              param.ids = this.selectRows.map(t=>t.record_id).join(",")

              editRecord(param).then((res)=>{
                if(res.errorcode==0){
                  this.$message.success('修改成功')
                  this.editDialogVisiable = false
                  this.getRecordList_()
                }else{
                  this.$message.error(res.message)
                }
              })
            });
          },
          editCloseHandler(){
            this.$refs['editForm'].resetFields()
            this.editForm = {
              weight: '',
              price: ''
            }
          },
          edit(){
            if(this.selectRows.length == 0){
              this.$message.error('请选择要修改的记录')
              return
            }
            this.editDialogVisiable  =true
          },
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            dataprint(printHTML)
          },
          productionChange(val){
            if(!val){
              this.specfilter = {}
              this.tecfilter = {}
            }else{
              this.specfilter = this.productfilter[val].spec
              this.tecfilter = this.productfilter[val].tec
            }
          },
            exportExcel(){
                tableDataToExcel(this.tableData,'生产记录',this.exportColumn)
            },
            search(){
                this.getRecordList_()
            },
            getRecordList_(){
                console.log(this.selectTime)
                if(!this.selectTime){
                    this.$message.error('请选择开始结束时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                getRecordList({
                    customerId: localCache.getCurrentCustomerId(),
                    beginTime: parseInt(this.selectTime[0].getTime()/1000),
                    endTime: parseInt(this.selectTime[1].getTime()/1000),
                    keyword: this.keyword,
                    priceType: this.priceType,
                    subEquipmentId: this.subEquipmentId,
                    departmentId:departmentId
                }).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                      this.tableData = res.data
                      setTimeout(()=>{
                        this.cacheData = res.data.slice(0)
                        this.productionFileter(res.data)
                      })
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            getEquipmentListAll_(){
                getEquipmentListAll({
                    customerId: localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.subEquipments=  res.data
                    }
                }).catch(() => {
                })
            },
            productionFileter(data){
              let d
              let p = {}
              for (let i = 0, len = data.length; i < len; i++) {
                d = data[i]
                if(!p[d.production_id]){
                  p[d.production_id] = {
                    name: d.production_name,
                    spec: {
                      [d.spec_id]: d.spec_name
                    },
                    tec: {
                      [d.technology_id]: d.technology_name
                    }
                  }
                }else{
                  p[d.production_id].spec[d.spec_id] = d.spec_name
                  p[d.production_id].tec[d.technology_id] = d.technology_name
                }
              }
              this.productfilter=p
              console.log(p)
            },
            getTree() {
                getDepartmentList({
                    customerId:localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.treeData = res.data
                    }
                }).catch(() => {
                })
            },
        }
    }
</script>

<style lang="scss">
    .record-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
    }

</style>
